(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bindReveals(root) {
    var els = qsa('[data-ss-reveal]', root);
    if (!els.length) return;
    if (prefersReducedMotion()) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function validateEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  }

  function showFieldError(field, msg) {
    field.classList.add('is-error');
    var wrap = field.closest('.smoke-contact__field');
    if (!wrap) return;
    var err = qs('.smoke-contact__error', wrap);
    if (!err) {
      err = document.createElement('p');
      err.className = 'smoke-contact__error';
      err.setAttribute('role', 'alert');
      wrap.appendChild(err);
    }
    err.textContent = msg;
  }

  function clearFieldError(field) {
    field.classList.remove('is-error');
    var wrap = field.closest('.smoke-contact__field');
    if (!wrap) return;
    var err = qs('.smoke-contact__error', wrap);
    if (err) err.remove();
  }

  function bindForm(root) {
    var form = qs('#smoke-contact-form', root) || qs('.smoke-contact__form', root);
    if (!form) return;

    var submitBtn = qs('[data-smoke-submit]', form);
    var submitLabel = qs('[data-smoke-submit-label]', form);
    var submitLoading = qs('[data-smoke-submit-loading]', form);

    form.addEventListener('submit', function (e) {
      var valid = true;
      qsa('[data-required]', form).forEach(function (field) {
        clearFieldError(field);
        var val = (field.value || '').trim();
        if (!val) {
          valid = false;
          var label = field.getAttribute('data-label') || 'This field';
          showFieldError(field, label + ' is required.');
        } else if (field.type === 'email' && !validateEmail(val)) {
          valid = false;
          showFieldError(field, 'Please enter a valid email address.');
        }
      });

      if (!valid) {
        e.preventDefault();
        var firstErr = qs('.is-error', form);
        if (firstErr) firstErr.focus();
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.hidden = true;
      if (submitLoading) submitLoading.hidden = false;
    });

    qsa('input, select, textarea', form).forEach(function (field) {
      field.addEventListener('input', function () { clearFieldError(field); });
      field.addEventListener('change', function () { clearFieldError(field); });
    });
  }

  function bindOpenToday(root) {
    var badge = qs('[data-smoke-open-today]', root);
    var hoursList = qs('[data-smoke-hours]', root);
    if (!badge || !hoursList) return;

    var hoursData;
    try {
      hoursData = JSON.parse(hoursList.getAttribute('data-hours') || '[]');
    } catch (e) { return; }

    if (!hoursData.length) {
      badge.hidden = true;
      return;
    }

    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var now = new Date();
    var todayKey = days[now.getDay()];
    var todayEntry = hoursData.find(function (h) { return h.day === todayKey; });

    qsa('li', hoursList).forEach(function (li) {
      if (li.getAttribute('data-day') === todayKey) li.classList.add('is-today');
    });

    if (!todayEntry || todayEntry.closed) {
      badge.textContent = 'Closed today';
      badge.classList.add('is-closed');
      return;
    }

    badge.textContent = 'Open today · ' + todayEntry.hours;
  }

  function init() {
    var root = qs('[data-smoke-contact]');
    if (!root) return;
    bindReveals(root);
    bindForm(root);
    bindOpenToday(root);

    if (window.location.hash === '#contact-form' || qs('.smoke-contact__alert--success', root)) {
      var formPanel = qs('#contact-form', root) || qs('.smoke-contact__form-panel', root);
      if (formPanel) formPanel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
